export const COUNTRIES = [
  {
    code: "GB",
    name: "United Kingdom",
    currency: "GBP",
    currencySymbol: "£",
    timezone: "Europe/London",
    timezones: ["Europe/London"],
    taxLabel: "VAT Number",
    taxPlaceholder: "GB123456789",
    regLabel: "Company Number",
    regPlaceholder: "12345678",
  },
  {
    code: "US",
    name: "United States",
    currency: "USD",
    currencySymbol: "$",
    timezone: "America/New_York",
    timezones: [
      "America/New_York",
      "America/Chicago",
      "America/Denver",
      "America/Los_Angeles",
      "America/Anchorage",
      "Pacific/Honolulu",
    ],
    taxLabel: "EIN",
    taxPlaceholder: "XX-XXXXXXX",
    regLabel: "State of Incorporation",
    regPlaceholder: "Delaware",
  },
  {
    code: "IN",
    name: "India",
    currency: "INR",
    currencySymbol: "₹",
    timezone: "Asia/Kolkata",
    timezones: ["Asia/Kolkata"],
    taxLabel: "GST Number",
    taxPlaceholder: "22AAAAA0000A1Z5",
    regLabel: "CIN",
    regPlaceholder: "U12345MH2020PTC123456",
  },
  {
    code: "AE",
    name: "United Arab Emirates",
    currency: "AED",
    currencySymbol: "د.إ",
    timezone: "Asia/Dubai",
    timezones: ["Asia/Dubai"],
    taxLabel: "TRN",
    taxPlaceholder: "100123456700003",
    regLabel: "Trade License Number",
    regPlaceholder: "CN-1234567",
  },
  {
    code: "SG",
    name: "Singapore",
    currency: "SGD",
    currencySymbol: "S$",
    timezone: "Asia/Singapore",
    timezones: ["Asia/Singapore"],
    taxLabel: "GST Registration",
    taxPlaceholder: "M12345678X",
    regLabel: "UEN",
    regPlaceholder: "202012345K",
  },
  {
    code: "AU",
    name: "Australia",
    currency: "AUD",
    currencySymbol: "A$",
    timezone: "Australia/Sydney",
    timezones: [
      "Australia/Sydney",
      "Australia/Melbourne",
      "Australia/Brisbane",
      "Australia/Perth",
      "Australia/Adelaide",
    ],
    taxLabel: "ABN",
    taxPlaceholder: "51 824 753 556",
    regLabel: "ACN",
    regPlaceholder: "000 000 019",
  },
  {
    code: "CA",
    name: "Canada",
    currency: "CAD",
    currencySymbol: "C$",
    timezone: "America/Toronto",
    timezones: [
      "America/Toronto",
      "America/Vancouver",
      "America/Winnipeg",
      "America/Halifax",
    ],
    taxLabel: "GST/HST Number",
    taxPlaceholder: "123456789 RT 0001",
    regLabel: "Business Number",
    regPlaceholder: "123456789",
  },
  {
    code: "DE",
    name: "Germany",
    currency: "EUR",
    currencySymbol: "€",
    timezone: "Europe/Berlin",
    timezones: ["Europe/Berlin"],
    taxLabel: "USt-IdNr",
    taxPlaceholder: "DE123456789",
    regLabel: "Handelsregisternummer",
    regPlaceholder: "HRB 12345",
  },
  {
    code: "NG",
    name: "Nigeria",
    currency: "NGN",
    currencySymbol: "₦",
    timezone: "Africa/Lagos",
    timezones: ["Africa/Lagos"],
    taxLabel: "TIN",
    taxPlaceholder: "12345678-0001",
    regLabel: "RC Number",
    regPlaceholder: "RC 123456",
  },
  {
    code: "ZA",
    name: "South Africa",
    currency: "ZAR",
    currencySymbol: "R",
    timezone: "Africa/Johannesburg",
    timezones: ["Africa/Johannesburg"],
    taxLabel: "VAT Number",
    taxPlaceholder: "4123456789",
    regLabel: "Company Registration",
    regPlaceholder: "2020/123456/07",
  },
];
